import { SUPPORTED_LOCALE_CODES } from '../../shared/locales.mjs';

// Portal choices share the canonical preference contract. Standalone controls
// retain their explicit option sets.
export const PORTAL_LOCALE_CODES = SUPPORTED_LOCALE_CODES;
